import uuid from "uuid/v4";
import messageTypes from "../constants/message_types";

/*
 * action types
 */

export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";
export const SHOW_MESSAGE_BAR = "SHOW_MESSAGE_BAR";
export const DISMISS_MESSAGE_BAR = "DISMISS_MESSAGE_BAR";

/*
 * action creators
 */
export function toggleSidebar() {
  return { type: TOGGLE_SIDEBAR };
}

export function showMessageBar(messageUUID, message, messageType) {
  return {
    type: SHOW_MESSAGE_BAR,
    messageUUID: messageUUID,
    messageType: messageType,
    message: message,
  };
}

export function dismissMessageBar(messageUUID) {
  return {
    type: DISMISS_MESSAGE_BAR,
    messageUUID: messageUUID,
  };
}

export function showMessageWithTimeout(message, messageType, timeout = 5000) {
  var messageUUID = uuid();
  return dispatch => {
    dispatch(showMessageBar(messageUUID, message, messageType));
    setTimeout(function() {
      dispatch(dismissMessageBar(messageUUID));
    }, timeout);
  };
}

export function showWarning(message, timeout) {
  return showMessageWithTimeout(message, messageTypes.Error, timeout);
}

export function showSuccess(message, timeout) {
  return showMessageWithTimeout(message, messageTypes.Success, timeout);
}
